import { isPlatformBrowser } from '@angular/common';
import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { LOCAL_STORAGE } from '../../../models/constant/constants';
import { StorageService } from '../storage.service/storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  storageService = inject(StorageService);
  // Default to localStorage
  private persistentStorage: Storage;
  private temporaryStorage: Storage;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any
  ) {    
    if (isPlatformBrowser(this.platformId)) {
      this.persistentStorage = localStorage; // Persistent storage for "Stay Signed In"
      this.temporaryStorage = sessionStorage; // Temporary storage for regular login
    } else {
      // Mocked or empty implementation for SSR
      this.persistentStorage = this.createMockStorage();
      this.temporaryStorage = this.createMockStorage();
    }
  }

  private createMockStorage(): Storage {
    return {
      setItem: (key: string, value: string) => { /* No-op */ },
      getItem: (key: string) => null,
      removeItem: (key: string) => { /* No-op */ },
      clear: () => { /* No-op */ },
      key: (index: number) => null,
      length: 0
    };
  }


  setToken(key: string, token: string, staySignedIn: boolean = this.storageService.getPersistentSignedIn()): void {
    const storage = staySignedIn ? this.persistentStorage : this.temporaryStorage;
    storage.setItem(key, token);
  }

  getToken(): string | null {
    return this.temporaryStorage.getItem(LOCAL_STORAGE.TOKEN) || this.persistentStorage.getItem(LOCAL_STORAGE.TOKEN);
  }

  getRefreshToken(): string | null {
    const userDetails =  this.temporaryStorage.getItem(LOCAL_STORAGE.USER_DETAILS) || this.persistentStorage.getItem(LOCAL_STORAGE.USER_DETAILS);
    const data = JSON.parse(userDetails as string);
    return data.refreshToken;
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  removeToken(key: string): void {
    this.temporaryStorage.removeItem(key);
    this.persistentStorage.removeItem(key);
  }

}
